import {Button, Menu, MenuItem, Popper} from '../../../components';
import {BaseIcon, NumberNo, Trash} from '../../../icons';
import {cn} from '../../../libs';
import {Rect} from '../../types';

interface RectMenuProps {
  rect: Rect;
  onChange: (rect: Rect) => void;
  onDelete: (rect: Rect) => void;
}

const colors = [
  {value: '#E43897', children: 'Розовый'},
  {value: '#EF4444', children: 'Красный'},
  {value: '#00A8FF', children: 'Синий'},
  {value: '#22C55E', children: 'Зеленый'},
  {value: '#FFA100', children: 'Оранжевый'},
  {value: '#FCD34D', children: 'Желтый'},
];

const names = [
  {value: '9'},
  {value: '8'},
  {value: '7'},
  {value: '6'},
  {value: '5'},
  {value: '4'},
  {value: '3'},
  {value: '2'},
  {value: '1'},
  {value: '-'},
];

export const RectMenu = ({rect, onChange, onDelete}: RectMenuProps) => {
  const renderColorIcon = (color: string, isSelected?: boolean) => {
    return (
      <div
        className="flex size-6 items-center justify-center rounded-full"
        style={{
          backgroundColor: color,
        }}
      >
        {isSelected && (
          <BaseIcon className="size-4">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M20 6.5L9 17.5L4 12.5"
              stroke="#fff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </BaseIcon>
        )}
      </div>
    );
  };

  const renderName = (name: string, isSelected?: boolean) => {
    return (
      <div className="flex size-6 items-center justify-center border-solid">
        <button
          type="button"
          className={cn(
            'size-6 justify-center rounded-sm border border-input-border px-0 text-center text-sm text-text-secondary',
            isSelected
              ? 'bg-bg-muted'
              : 'cursor-pointer hover:border-input-border-hover hover:bg-bg-primary',
          )}
        >
          {name}
        </button>
      </div>
    );
  };

  const onClickDelete = () => {
    onDelete(rect);
  };

  return (
    <Menu className="w-fit p-2">
      <div className="flex gap-2">
        {rect.type === 'highlight' && (
          <Popper
            menu={
              <Menu className="p-px">
                {colors.map((color) => (
                  <MenuItem
                    key={`color-${color.value}`}
                    className="px-0"
                    onClick={() => {
                      onChange({...rect, color: color.value});
                    }}
                  >
                    <div className="flex justify-center">
                      {renderColorIcon(color.value, color.value === rect.color)}
                    </div>
                  </MenuItem>
                ))}
              </Menu>
            }
            placement="top"
          >
            <Button variant="outline" shape="square" size="icon">
              {renderColorIcon(rect.color || colors[0].value)}
            </Button>
          </Popper>
        )}

        {rect.type === 'highlight' && (
          <Popper
            menu={
              <Menu className="p-px py-1">
                {names.map((name) => (
                  <MenuItem
                    key={`name-${name.value}`}
                    className="px-0 py-1 hover:bg-inherit"
                    onClick={() => {
                      onChange({...rect, name: name.value});
                    }}
                  >
                    <div className="flex justify-center">
                      {renderName(name.value, name.value === rect.name)}
                    </div>
                  </MenuItem>
                ))}
              </Menu>
            }
            placement="top"
          >
            <Button variant="outline" shape="square" size="icon">
              <NumberNo className="size-6" />
            </Button>
          </Popper>
        )}

        <Button variant="outline" shape="square" onClick={onClickDelete}>
          <Trash className="size-6" />
        </Button>
      </div>
    </Menu>
  );
};
